import { WprViewMode } from '../../wpr-framework/view/deco/WprViewMode';
import { RegistMailMode } from './mode/RegistMailMode';
import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { FirstScopeInfo } from '../../scope/FirstScopeInfo';
import { WprBaseScopeViewInfo } from '../../wpr-framework/view/WprBaseScopeViewInfo';
import { SendAuthMailRequest } from '../../service/service-models/send-auth-mail/SendAuthMailRequest';
import { AuthMailInfo } from '../../service/models/auth-mail/auth-mail-info';
import { RiskFactorInfo } from '../../service/models/risk-factor/risk-factor-info';
import { SelectPlanInfo } from '../../service/models/select-plan/select-plan-info';
import { MailAuthService } from '../../service/MailAuthService';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';

/**
 * メール登録ビュー情報
 */
export class RegistMailComponentView extends BaseWindowViewScope<FirstScopeInfo> {
	// モデル -------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode:		string			= null;
	@WprDI_ScopeModel('AuthMailInfo')
	@WprModel('AuthMailInfo')
	private m_AuthMailInfo:		AuthMailInfo	= null; // 	認証メール情報
	@WprDI_ScopeModel('RiskFactorInfo')
	private m_RiskFactorInfo:	RiskFactorInfo	= null;	//	リスクファクタ情報
	@WprDI_ScopeModel('SelectPlanInfo')
	private m_SelectPlanInfo:	SelectPlanInfo	= null;	//	選択プラン情報
	// --------------------------------------------------------------------------

	// サブビュー/モード  ---------------------------------------------------------
	@WprViewMode
	private m_ViewMode = new RegistMailMode(); // メール登録モード
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('step4_mail-registration');
	}
	// --------------------------------------------------------------------------

	// サービス  -----------------------------------------------------------------
	private m_MailAuthService: MailAuthService = new MailAuthService();	// 認証メールサービス
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		this.addConfig('mailAddress',	'メール入力',				'AuthMailInfo', { hissu: true, validation: 'メールアドレス', noEditClass: 'first', errorClass: 'error' });
		this.addConfig('buttonName',	'ボタンに表示される名前',	  null);
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		super.onRegisterAction();
		this.addBlurAction('mailAddress', null, true);
		this.addAction('sendMail',	this.onSendMail);
	}

	/**
	 * バリデーションエラーメッセージ通知
	 * @param name コントロール名
	 * @param rowIndex 行数(Listの場合)
	 * @param validatorName バリデーション名
	 * @param msg エラーメッセージ
	 * @returns エラーメッセージ（変更する場合に指定する、メッセージを使用しない場合は、nullを返す）
	 */
	public onInvalidMessage(name: string, rowIndex: number,	validatorName: string, msg: string): string {
		if (name === 'mailAddress')
			return '英数字、「@」（アットマーク）、「-」（ハイフン）、「.」（ドット）、「_」（アンダーバー）のいずれかで入力してください。';
		return msg;
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		this.m_AuthMailInfo = new AuthMailInfo();
		this.setScopeModel('AuthMailInfo', this.m_AuthMailInfo);
		this.onUtagView();
		this.refreshView();
		$('#id-mail-address').off('click');
	}
		
	/**
	 * ロストフォーカス通知
	 * @param name コントロール名称
	 * @param value コントロール値
	 * @returns コントロール値（コントロール値を変更しない場合は、valueをそのまま返す）
	 */
	public onBlur(name: string, value: any): any {
		if (name === 'mailAddress') {
			return value.replace(/[Ａ-Ｚａ-ｚ０-９＠＿－．]/g, function(match) {
				return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
			});
		}
		return value;
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------

	// アクション  ---------------------------------------------------------------
	/**
	 * メール送信処理
	 */
	public onSendMail(param: any): void {
		this.refreshModel();
		const req = new SendAuthMailRequest();
		req.authMailInfo = new AuthMailInfo();
		req.authMailInfo.mailAddress 	= this.m_AuthMailInfo.mailAddress;
		req.authMailInfo.riskFactorInfo = this.m_RiskFactorInfo;
		req.authMailInfo.selectPlanInfo = this.m_SelectPlanInfo;
		this.m_MailAuthService.sendAuthMail(this, req, (result) => {
			this.pushPath('/step4_mail-finish');
		});
	}
	// --------------------------------------------------------------------------
}